import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
  EntidadEmpresarial,
  InformacionUsuarioEntity,
  ParametrosImprimirAdmisionEntity,
  ServicioImprimirAdmisionService
} from 'src/app/services/servicio-imprimir-admision.service';
import {ServicioMedicamentosHomologadosService} from 'src/app/services/servicio-medicamentos-homologados.service';

@Component({
  selector: 'app-reporte-registro-medicamentos',
  templateUrl: './reporte-registro-medicamentos-insumos.component.html',
  styleUrls: ['./reporte-registro-medicamentos-insumos.component.css']
})
export class ReporteRegistroMedicamentosInsumosComponent implements OnInit {
  private parametrosUrl: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: ''
  };

  public errorDataReporte = false;
  public mensajeError = 'Error al generar los datos del reporte. Por favor recargar el sitio, si el problema persiste, comunicarse con el administrador.';
  public loading = true;
  public error = false;
  public dataReporte: any[] = [];
  public fechaImpresion = new Date();
  public dataAfiliado: any = {};
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };
  public dataUsuario: InformacionUsuarioEntity = {
    nombreUsuario: '',
    codigoBarrasImprime: ''
  };

  @ViewChild('containerHeaderFixedForPrint') containter: ElementRef;
  @ViewChild('trColumns') trColumns: ElementRef;

  constructor(
    private servicioAdmision: ServicioImprimirAdmisionService,
    private servicioMedicamentos: ServicioMedicamentosHomologadosService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.parametrosUrl.codigoBaseDatos = params.codigoBaseDatos;
      this.parametrosUrl.uncoSede = params.uncoSede;
      this.parametrosUrl.uncoLogin = params.uncoLogin;
      this.parametrosUrl.uncoAdmision = params.uncoAdmision;
    });
  }

  ngOnInit() {

    this.getInfoEntidadEmpresarial();
    this.getInfoUsuario();

    const context = this, afterPrint = () => {
      context.processColumnsInPrint(null);
      context.containter.nativeElement.className = null;
    };

    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(function(mql) {
        if (!mql.matches) {
          afterPrint();
        }
      });
    } else {
      window.onafterprint = afterPrint;
    }
    this.getDataMedicamentosInsumos();
  }

  public getGenerar() {
    this.getDataMedicamentosInsumos();
  }

  public getPrint() {
    this.containter.nativeElement.className = 'page-header';
    this.processColumnsInPrint('294px');
    window.print();
  }

  private processColumnsInPrint (value) {
    const children = this.trColumns.nativeElement.children;
    for (const child of children) {
      child.firstChild.style.height = value;
    }
  }

  private async getInfoUsuario() {
    const response = await this.servicioAdmision.getInformacionUsuario(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataUsuario = data[0];
      }
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoEntidadEmpresarial() {
    const response = await this.servicioAdmision.getEntidadEmpresarial(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataEntidadEmpresarial = data[0];
      }
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getDataMedicamentosInsumos() {

    const response = await this.servicioMedicamentos.getDataMedicamentosInsumos(this.parametrosUrl.codigoBaseDatos, +this.parametrosUrl.uncoAdmision);

    response.subscribe( (data: any) => {
      if (data != null) {
        if (!data.error) {
          if (data.data.length > 0) {
            this.dataAfiliado = data.data[0];
          }
          this.dataReporte = data.data;
        } else {
          this.mensajeError = data.mensaje;
          this.errorDataReporte = true;
        }
      }
      this.loading = false;
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }
}
